import { useRef, useState } from 'react'
import Popup from "../../popup"
import TextArea from '@/components/formFields/TextArea'

const TextPopup = ({ onApply, textRef }) => {


  const [text, setText] = useState("")

  return (
    <>
      <Popup needbtn={!!onApply} onApply={() => onApply(text)} large={false} title={"reject-request"} name={`img-${Date.now()}`} modalID={textRef}>
        <TextArea className={"col-lg-12"} label="reject-note"  name="note" value={text} setValue={(value) => setText(value)} />
      </Popup>
    </>
  )
}

export default TextPopup